import React, { useState } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";

import { getCommaNumber } from "utils/format";
import iconDrop from "assets/icons/icon_drop_black.svg";

import Button from "components/ui/Button";

/**
 * [기간별 매출 개요 - 내역 보기]
 */

export const PeriodList = () => {
  const { searchPeriodType } = useSelector((state) => state.sales);
  const { data } = useSelector((state) => state.sales.summaryInfo);
  const [state, setState] = useState(false);

  const eventHandler = {
    toggle: () => {
      setState(!state);
    },
  };

  const render = () => {
    const getDateInfo = (item) => {
      switch (searchPeriodType) {
        case "daily":
          return new Date(item.date).format("sm.sd (sw)");

        case "weekly":
          const month = new Date(item.startDate).add(0, 0, 3).getMonth() + 1;
          const weekInMonth = new Date(item.startDate).getWeekInMonth();
          return `${month}월 ${weekInMonth}주차`;

        case "monthly":
          return new Date(item.yearMonth + "-01").format("zm월");
      }
    };

    const summaryList = [].concat((data || {}).summaryList || []).reverse();
    const li = summaryList.map((item) => {
      return (
        <li key={item.date || item.startDate || item.yearMonth}>
          <div>
            <div>{getDateInfo(item)}</div>
            <div>{getCommaNumber(item.totalSalesAmount)}원</div>
          </div>
          <div>
            <div>
              b.pay
              <span>{getCommaNumber(item.bpaySalesCount)}건</span>
            </div>
            <div>{getCommaNumber(item.bpaySalesAmount)}원</div>
          </div>
          <div className="small">
            <div>
              <div className="row">
                <div>모바일 결제</div>
                <span>{getCommaNumber(item.bpayAppSalesCount)}건</span>
              </div>
              <div>{getCommaNumber(item.bpayAppSalesAmount)}원</div>
            </div>
            <div>
              <div className="row">
                <div>키오스크 결제</div>
                <span>{getCommaNumber(item.bpayKioskSalesCount)}건</span>
              </div>
              <div>{getCommaNumber(item.bpayKioskSalesAmount)}원</div>
            </div>
          </div>
          <div>
            <div>
              현장판매
              <span>{getCommaNumber(item.crmSalesCount)}건</span>
            </div>
            <div>{getCommaNumber(item.crmSalesAmount)}원</div>
          </div>
          <div className="small">
            <div>
              <div className="row">
                <div>수기 결제</div>
                <span>{getCommaNumber(item.crmManualSalesCount)}건</span>
              </div>
              <div>{getCommaNumber(item.crmManualSalesAmount)}원</div>
            </div>
            <div>
              <div className="row">
                <div>키오스크 결제</div>
                <span>{getCommaNumber(item.crmKioskSalesCount)}건</span>
              </div>
              <div>{getCommaNumber(item.crmKioskSalesAmount)}원</div>
            </div>
          </div>
          <div>
            <div>
              환불
              <span>{getCommaNumber(item.refundCount)}건</span>
            </div>
            <div>{getCommaNumber(item.refundAmount * -1)}원</div>
          </div>
        </li>
      );
    });

    const getLabel = () => {
      switch (searchPeriodType) {
        case "daily":
          return "최근 7일간 내역";
        case "weekly":
          return "최근 6주간 내역";
        case "monthly":
          return "최근 6개월간 내역";
      }
    };

    const getButton = () => {
      return state ? (
        <Button color="lightGray" outline onClick={eventHandler.toggle}>
          내역 접기
        </Button>
      ) : (
        <Button color="lightGray" outline onClick={eventHandler.toggle}>
          {getLabel()} 더보기
        </Button>
      );
    };

    return (
      <Wrapper className={state ? "focus" : null}>
        <div className="detail">
          <div>
            <h4>{getLabel()}</h4>
            <ul>{li}</ul>
          </div>
        </div>
        {getButton()}
      </Wrapper>
    );
  };
  return render();
};

const Wrapper = styled.div`
  button:after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    margin-left: 0.5em;
    width: 12px;
    height: 12px;
    background: url(${iconDrop}) no-repeat center center / 12px;
    opacity: 0.66;
  }
  &.focus button:after {
    margin-top: -4px;
    transform: rotate(-180deg);
  }

  .detail {
    height: 0;
    overflow: hidden;
    transition: height 0.4s;
  }
  &.focus .detail {
    margin-bottom: 5px;
    height: auto;
  }
  .detail h4 {
    padding-top: 15px;
    font-size: var(--16px);
    font-weight: 600;
    color: #6a7592;
  }
  .detail b {
    color: var(--black);
  }
  .detail li {
    padding: 16px 0;
    color: #515458;
  }
  .detail li > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: var(--14px);
  }
  .detail li > div:first-child {
    font-size: var(--16px);
    font-weight: 600;
  }
  .detail li > div:first-child div {
    color: var(--black);
  }
  .detail li > div + div {
    margin-top: 6px;
  }

  .detail li > div.small {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-size: var(--12px);
    margin-top: 4px;
    width: 100%;
  }

  .detail li > div.small > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    color: var(--gray);
  }

  .detail li > div.small > div > div.row {
    display: flex;
    align-items: center;
    margin-left: 8px;
  }

  .detail li > div.small > div > div.row > span::before {
    margin: 0 3px;
  }

  .detail li span {
    font-size: var(--12px);
    color: var(--gray);
  }
  .detail li span:before {
    content: "·";
    margin: 0 0.3em;
  }
  .detail li + li {
    border-top: 1px solid var(--lightBorder);
  }
`;

export default PeriodList;
